import React, { createContext, useState, useContext, ReactNode } from "react";

interface ModalContent {
    title: string;
    message: string;
    ctaTitle: string;
    cb: () => any;
    icon: string;
}

interface ModalContextType {
    modalId: string;
    setModalId: (id: string) => void;
    modalContent: ModalContent;
    setModalContent: (content: ModalContent) => void;
    isLoading: boolean;
    setIsLoading: (loading: boolean) => void;
}

// Modal provider for global modals
export const ModalContext = createContext<ModalContextType>({
    modalId: "",
    setModalId: () => {},
    modalContent: {
        title: "",
        message: "",
        ctaTitle: "",
        cb: () => ({}),
        icon: "",
    },
    setModalContent: () => {},
    isLoading: true,
    setIsLoading: () => {},
});

interface ModalProviderProps {
    children: ReactNode;
}

const ModalProvider = ({ children }: ModalProviderProps) => {
    const [modalContent, setModalContent] = useState<ModalContent>({
        title: "",
        message: "",
        ctaTitle: "",
        cb: () => ({}),
        icon: "",
    });
    const [modalId, setModalId] = useState<string>("");
    const [isLoading, setIsLoading] = useState<boolean>(true);

    return (
        <ModalContext.Provider value={{ modalId, setModalId, modalContent, setModalContent, isLoading, setIsLoading }}>
            {children}
        </ModalContext.Provider>
    );
};

export const useModal = (): ModalContextType => useContext(ModalContext);

export default ModalProvider;
